// 1 CvantoCoin = 1 UAH = 100 minor units (kopecks). Kept in sync by
// convention with server/services/paymentFulfillmentService.js's
// COIN_TO_MINOR_RATE — there is no shared build step between frontend and
// backend, so this constant exists purely so every frontend call site
// imports one number instead of re-hardcoding "100".
export const COIN_TO_MINOR_RATE = 100;

export function coinsToMinor(coins) {
  return Math.round(Number(coins) * COIN_TO_MINOR_RATE);
}
